import { createContext } from 'react';

import Device from '~interfaces/device';

export interface DeviceContextValue {
	device: Device | undefined;
	overwrittenClientId: string | undefined;
}

const DeviceContext = createContext<DeviceContextValue>({
	device: undefined,
	overwrittenClientId: undefined,
});

export default DeviceContext;
